(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  // Relocate the trust badges between the social row (desktop) and the
  // bottom slot (mobile) without re-inserting markup, so any embedded
  // script (e-mærket) never re-executes.
  (() => {
    const trust = document.querySelector('[data-footer-trust]');
    const slot = document.querySelector('[data-footer-trust-slot]');
    if (!trust || !slot) return;

    const desktopParent = trust.parentElement;
    const desktopNextSibling = trust.nextElementSibling;

    const place = () => {
      const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
      if (isLargeScreen) {
        if (trust.parentElement !== desktopParent) {
          desktopParent.insertBefore(trust, desktopNextSibling);
        }
        desktopParent.hidden = false;
        slot.hidden = true;
      } else {
        if (trust.parentElement !== slot) {
          slot.appendChild(trust);
        }
        // Hide the social row on mobile if it's now empty (only had trust badges)
        const hasOtherContent = desktopParent.querySelector(':scope > :not([data-footer-trust])');
        desktopParent.hidden = !hasOtherContent;
        slot.hidden = false;
      }
    };

    place();
    window.addEventListener('on:breakpoint-change', place);
  })();

  } catch(e) { console.error(e); }
})();
})();
